// src/utils/signatures.js
const signatures = {
  "akedanai@neonworks.co.th":
    "https://res.cloudinary.com/dflnrw7va/image/upload/v1750048833/signatures/rwtrasw7q6tcslrsvmhf.png",
  "natorn@neonworks.co.th":
    "https://res.cloudinary.com/dflnrw7va/image/upload/v1769746039/signature_pai_ksx2ad.png",
  "chawachai@optx.co.th":
    "https://res.cloudinary.com/dflnrw7va/image/upload/v1744862831/signatures/o4hejus1csvir7opjuak.png",
};

export default signatures;
